import React from 'react';
import { Checkbox, Collapse } from 'antd';
import RdfTypeCount from '../widgets/RdfTypeCount';
import Label from '../widgets/Label';

const Panel = Collapse.Panel;

/** Сформировать условия для отбора или снятия отбора  */
function makeRdfTypeCondition (rdfType) {
  return {
    predicate: "http://www.w3.org/1999/02/22-rdf-syntax-ns#type", 
    operator: "=", 
    value: rdfType, 
    alias:"type", 
    label:rdfType,
    type: "uri",
    scheme: "http://www.w3.org/1999/02/22-rdf-syntax-ns#type",
    //Переменная, к которой используется условие. см. addAliasInWhere в virtuoso/filter.js
    variable: "IRI"
  };
};

/**
 * Проверка на установку галки в чекбоксе
 */
const hasChecked = (rdfType, selected) =>{
  return (selected)? selected.filter(
    item => (Array.isArray(item.value)?item.value.indexOf(rdfType)>=0:item.value==rdfType)
  ).length>0: false;  
}

/** Отображение  списка типов объектов, которые могут использоваться для фильтрации.
*/
class VocabsFilter extends React.Component {	

  onChangeType(e, rdfType) {
    e.preventDefault();
    //console.log(`checked = ${e.target.checked}`, e, concept, this);
    const {onChange, selected, view} = this.props;
    const condition = makeRdfTypeCondition(rdfType);
    if (onChange) 
      onChange(e.target.checked, condition);    
  };

  onChangeНighlight(e){
    e.preventDefault();
  };

  render() {
    const {rdfTypes, selected, highlight} = this.props;
    //console.log(this);
    return (
      <span className="csi_taxonomy" >
        <Collapse defaultActiveKey={['1', '2']} >        
        <Panel header={"Типы объектов"} key="1" onClick={(e) => e.stopPropagation()}>
        {rdfTypes && rdfTypes.map((rdfType, i) => { 
          const isChecked = hasChecked(rdfType, selected);
          return (
            <p key={i}>
              <Checkbox checked={isChecked} onChange={(e) => this.onChangeType(e, rdfType)}>
                <Label iri={rdfType}/>&nbsp;{<RdfTypeCount IRI={rdfType} />}
              </Checkbox>
            </p>
          )
        })}        
        </Panel>
        {/* {Array.isArray(highlight) && highlight.length>0 && (
          <Panel header={"Выделенные объекты"} key="2" onClick={(e) => e.stopPropagation()}>
            <p>
              <Checkbox checked={false} onChange={(e) => this.onChangeНighlight(e)}>
                Отобрать в список &nbsp;({highlight.length})
              </Checkbox>
            </p>
          </Panel>
        )} */}
        </Collapse>
      </span>
    )
  }
}

export default VocabsFilter;